<script lang="ts">
    import { TodayTotalRevenue, Tomorrow, UpdatedProducts } from "../../../utils/Constant/Constant";
</script>

<div class="media">
    <div class="activity-dot-primary" />
    <div class="media-body d-block">
        <h6><span class="font-primary">20-04-2021</span>{Tomorrow}</h6>
        <h5>
            {TodayTotalRevenue}<i
                class="fa fa-circle circle-dot-primary pull-right"
            />
        </h5>
        <p>{UpdatedProducts}</p>
    </div>
</div>
